import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{attrs:{"outlined":"","tile":""}},[_c('div',{staticClass:"py-3 text-center"},[_c(VIcon,{attrs:{"x-large":"","color":"success"}},[_vm._v(_vm._s(_vm.icon))])],1),_c('hr',{staticClass:"m-0"}),_c(VCardText,{staticClass:"text-center"},[_c('h4',[_vm._v(_vm._s(_vm.data.count))]),_c('strong',[_vm._v(_vm._s(_vm.name))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }